module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "sec_chap"
  }, [_vm._v("Corrections to Volume Two")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("o ensure compatibility between the two narrative volumes and the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Documentary Companion")]), _vm._v(", the following corrections are necessary to the marginal annotations in Volume two of the narrative:")]), _vm._v(" "), _c('p', {
    staticClass: "bullett"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter_11#ch11sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Page 141")]), _vm._v(" – change R, 21 to R, 1.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter_11#page_142",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Page 142")]), _vm._v(" – change R, 22 to R, 2.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter_14#page_196",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Page 196")]), _vm._v(" – change S, 20 to S, 17.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter_15#page_218",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Page 218")]), _vm._v(" – change S, 24 to S, 23.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter_15a#page_243",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Page 243")]), _vm._v(" – change S, 32 to S, 35 and change S, 34 to S, 33.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter_15b#ch15sec57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Page 283")]), _vm._v(" – change S, 48-51 to S, 48, 51, 49, and 50.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter_19a#page_421",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Page 421")]), _vm._v(", note 4, ln. 4 – change “Impossibility of” to “Necessity for”")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix U")]), _vm._v(", which pertains to the operations by "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Armeegruppe")]), _vm._v(" Guderian and the Briansk Front’s Roslavl’-Novozybkov offensive, is split into three parts associated with three distinct periods of time.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter_21#page_493",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Page 493")]), _vm._v(" – Add “See Volume 3 (Documents) U, 77.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b82391a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/10_Corrections.vue
// module id = 87
// module chunks = 0